const invalidAccessTooltipText = 'You do not have permissions to view this page. Please contact your system administrator.';

const isInvaluableSeller = window.location.hostname.indexOf('sellers') >= 0;

const isSothebys = houseID => houseID === 46;

export { invalidAccessTooltipText, isInvaluableSeller, isSothebys };
